module.exports = __webpack_public_path__ + "static/scopriabitareco_experiences_eventi-b057f28320ec6356783a213c3a08dfdf.jpg";